(function() {
    const sticky = document.querySelector('#StickyBuyBar');
    if (!sticky) return;

    let lastScroll = 0;
    window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY;

    if (currentScroll > lastScroll && currentScroll > 50) {
        sticky.classList.remove('hide');
    } else if (currentScroll < lastScroll && currentScroll <= 50) {
        sticky.classList.add('hide');
    }

    lastScroll = currentScroll;
    });
})();
